import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-support',
    templateUrl: './common-support.component.html',
    styleUrls: ['./common-support.component.scss'],
    standalone: false
})
export class CommonSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
